module.exports = __webpack_public_path__ + "img/info-bar-chart2.0e48a296.svg";